import { useState, useEffect } from 'react';
import LogoNegro from '/public/LogoNegro.svg';
import LogoNegro_sm from '/public/LogoNegro_sm.svg';
import LogoBlanco from '/public/LogoBlanco.svg';
import LogoBlanco_sm from '/public/LogoBlanco_sm.svg';

// Define a functional component
const LogoNavbar = ({themeContext}) => {
    // State variable to store the image source
    const [imageSrc, setImageSrc] = useState('');

    // Function to determine image source based on screen size
    const setImageBasedOnScreenSize = () => {
        // Check if the screen size is small
        if (window.innerWidth < 640) {
            setImageSrc(themeContext === 'light' ? LogoNegro_sm : LogoBlanco_sm);

        } else {
            setImageSrc(themeContext === 'light' ? LogoNegro : LogoBlanco);
        }
    };

    // Use useEffect hook to set the image source initially and on window resize
    useEffect(() => {
        // Set the initial image source based on screen size
        setImageBasedOnScreenSize();

        // Add event listener for window resize
        window.addEventListener('resize', setImageBasedOnScreenSize);

        // Cleanup function to remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', setImageBasedOnScreenSize);
        };
    }, [themeContext]); // Re-run effect when themeContext changes

    return (
        <img
            alt="Logo customiz3d"
            className="imgLogo mr-3 h-6 md:h-7 lg:h-7 xl:h-7 2xl:h-8"
            src={imageSrc}
        />
    );
};

export default LogoNavbar;
